module.exports = __webpack_public_path__ + "img/schets-17.7f68e81e.jpg";